import { Box, Grid, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
	summaryPaper: {
		padding: theme.spacing(2),
		marginBottom: theme.spacing(2),
		backgroundColor: "#e3f2fd",
	},
	summaryItem: {
		textAlign: "center",
	},
	summaryLabel: {
		fontSize: "0.875rem",
		color: theme.palette.text.secondary,
		fontWeight: 500,
	},
	summaryValue: {
		fontSize: "1.5rem",
		fontWeight: 600,
		color: theme.palette.primary.main,
	},
}));

export const PalletsSummary = ({
	summaryTotals,
	titleKey = "tab.pallets.summary",
	palletsLabelKey = "tab.pallets.total_pallets",
	boxesLabelKey = "tab.pallets.total_boxes",
	weightLabelKey = "tab.pallets.total_weight",
}) => {
	const classes = useStyles();
	const translate = useTranslate();

	if (!summaryTotals) return null;

	const totalPallets = summaryTotals.total_pallets || 0;
	const totalBoxes = summaryTotals.total_boxes || 0;
	const totalWeight = Number(summaryTotals.total_weight || 0).toFixed(2);

	return (
		<Paper className={classes.summaryPaper}>
			<Box>
				<Typography variant="h6" gutterBottom>
					{translate(titleKey)}
				</Typography>
				<Grid container spacing={3}>
					<Grid item xs={12} sm={4}>
						<Box className={classes.summaryItem}>
							<Typography className={classes.summaryLabel}>
								{translate(palletsLabelKey)}
							</Typography>
							<Typography className={classes.summaryValue}>{totalPallets}</Typography>
						</Box>
					</Grid>
					<Grid item xs={12} sm={4}>
						<Box className={classes.summaryItem}>
							<Typography className={classes.summaryLabel}>
								{translate(boxesLabelKey)}
							</Typography>
							<Typography className={classes.summaryValue}>{totalBoxes}</Typography>
						</Box>
					</Grid>
					<Grid item xs={12} sm={4}>
						<Box className={classes.summaryItem}>
							<Typography className={classes.summaryLabel}>
								{translate(weightLabelKey)}
							</Typography>
							<Typography className={classes.summaryValue}>{totalWeight} kg</Typography>
						</Box>
					</Grid>
				</Grid>
			</Box>
		</Paper>
	);
};
